import { render } from "./RedBack.svg?vue&type=template&id=55db5622"
const script = {}
script.render = render

export default script